module.exports = __webpack_public_path__ + "static/media/ic-back-arrow.ece2941f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic-back-arrow.svg
// module id = 297
// module chunks = 0